
import { Link } from 'react-router-dom';

import { useState } from 'react';

const PageSix = () => {
  const [redirecting, setRedirecting] = useState(false);

  const handleCipherClick = (_e: React.MouseEvent<HTMLAnchorElement>) => {
    if (redirecting) return;
    
    setRedirecting(true);
    console.log("Cipher button clicked - navigating to initiation page");
    
    // Set a flag in localStorage to indicate this is an intentional connect
    localStorage.setItem('cipher-intent', 'true');
  };

  return (
    <>
      <p className="text-xl font-bold text-foreground">THE LAW</p>
      <ul className="list-disc list-inside text-xl pl-6 space-y-2 text-foreground">
        <li>Cheaters: BroScore burned, public shame posted</li>
        <li>Ghosters: Auto-forfeit and penalty</li>
        <li>Disputes: Settled by community vote</li>
      </ul>
      
      <p className="text-xl mt-4 text-foreground">All actions are written to the BroLedger. No edits. No mercy.</p>
      
      <p className="text-xl mt-6 text-foreground">You don't need FOMO.</p>
      <p className="text-xl text-foreground">You get the Joy of Missing Out—on comfort, on silence, on softness.</p>
      <p className="text-xl text-foreground">This is not a game.</p>
      <p className="text-xl text-foreground">It's your public path to proof, purpose, and primal brotherhood.</p>
      
      <div className="flex items-center space-x-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain"
        />
        <p className="text-xl text-foreground">Honor the code. Trust the process.</p>
      </div>
      
      <div className="flex items-center space-x-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain"
        />
        <p className="text-xl text-foreground">Your BroCode is your bond.</p>
      </div>
      
      <div className="mt-12 text-center">
        <Link 
          to="/initiation" 
          className="bg-primary text-primary-foreground px-8 py-3 rounded-lg text-xl font-bold hover:bg-primary/90 transition-colors"
          onClick={handleCipherClick}
        >
          TAKE THE CIPHER
        </Link>
      </div>
    </>
  );
};

export default PageSix;
